// extracted by mini-css-extract-plugin
module.exports = {"container":"Imagem_container__pAMzD","imagem":"Imagem_imagem__3_1HN","info":"Imagem_info__2AxD1","descricao":"Imagem_descricao__vzfCd","opcoes":"Imagem_opcoes__1NBUv"};